<template>
  <div class="h-100">
    <cc-sidebar ref="sidebarRightFilter" id="sidebar-right-filter"
                title="Điều kiện tìm kiếm"
                @onOpenedSidebar="onOpenedSidebar">
      <template slot="body">
        <filter-panel ref="filterPanel" :pathUrl="pathUrl" :nameByUser="pFullName"></filter-panel>
      </template>
      <template slot="footer">
        <div class="align-items-center p-3">
          <CRow>
            <CCol :col="{size: 10, offset: 1}">
              <CRow>
                <CCol col="6">
                  <CButton block color="danger" size="sm" @click="resetCondition">Xóa điều kiện</CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" size="sm" @click="filterListWithCondition">Tìm kiếm</CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>
    </cc-sidebar>
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <cc-ve-table ref="ccVeTable" namespace="zoneNews" :columns="columns" :expand-option="expandOption"
                     :cell-style-option="cellStyleOption" :event-custom-option="eventCustomOption"
                     @onChangeItemsPerPage="onChangeItemsPerPage" @onChangePagination="onChangePagination"
                     @itemSelectedLength="getItemSelectedLength">
          <template slot="cCardHeader">
            <CRow>
              <CCol col="7">
                <h4 class="text-uppercase mb-0 mt-1">
                  {{ newsTypeScreen[pathUrl]['title'] }}
                  <span v-if="pathUrl === 'by-user' || pathUrl === 'by-me'"
                        class="text-capitalize text-crimson">
                    {{ pFullName }}
                  </span>
                </h4>
              </CCol>
              <CCol col="5" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="5">
                        <CButton block color="danger"
                                 :disabled="!itemSelectedLength"
                                 @click="deleteSelectedTable">
                          Xóa
                        </CButton>
                      </CCol>
                      <CCol col="5">
                        <CButton block color="success" @click="$router.push(`/zoning/new/${pathUrl==='map'? 'price': 'basic'}`)">Thêm mới</CButton>
                      </CCol>
                      <CCol col="2" class="text-center align-self-center">
                        <CLink href="#" v-b-toggle.sidebar-right-filter>
                          <CIcon name="cil-filter" height="20"/>
                        </CLink>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
        </cc-ve-table>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import CcVeTable from '@/components/common/tableList/CcVeTable'
import CcSidebar from '@/components/common/CcSidebar'
import {NEWS_STATUS, NEWS_APPROVAL_STATUS, NEWS_TYPE_SCREEN} from '@/common/Constant'
import {SHOW_TOAST_2} from '@/common/lib'
import moment from 'moment'
import ExpandInfoList from '@/components/zoning/ExpandInfoList'
import FilterPanel from '@/components/zoning/FilterPanel'
import * as _ from 'lodash'

export default {
  name: 'List',
  components: {
    CcVeTable,
    // eslint-disable-next-line vue/no-unused-components
    ExpandInfoList,
    CcSidebar,
    FilterPanel
  },
  data() {
    return {
      pFullName: '',
      itemSelectedLength: 0,
      newsTypeScreen: NEWS_TYPE_SCREEN,
      pathUrl: null,
      columns: [
        {
          field: 'title',
          key: 'id',
          title: 'Tiêu đề bài đăng',
          align: 'left',
          width: 420,
          renderBodyCell: ({row, column}) => {
            return (
              <router-link class="font-weight-bold" to={`/zoning/edit/${row[column.key]}`}>
                {row[column.field]}
              </router-link>
            )
          }
        },
        {
          title: 'Khu vực',
          children: [
            {
              field: 'province_name',
              key: 'province_name',
              title: 'Tỉnh',
              align: 'left',
              width: 150
            },
            {
              field: 'district_name',
              key: 'district_name',
              title: 'Huyện',
              align: 'left',
              width: 150
            },
            {
              field: 'commune_name',
              key: 'commune_name',
              title: 'Xã',
              align: 'left',
              width: 150
            }
          ]
        },
        {
          field: 'status',
          key: 'status',
          title: 'Loại tin',
          align: 'center',
          width: 90,
          renderBodyCell: ({row, column}) => {
            let _status
            NEWS_STATUS.forEach(status => {
              if (status.id === row[column.field]) {
                _status = (
                  <CBadge color={status.bgColor}
                          style="padding: 0.4em 0.6em !important; font-size: 0.8em !important;">
                    {status.name}
                  </CBadge>
                )
              }
            })
            return _status
          }
        },
        {
          field: 'is_highlight',
          key: 'is_highlight',
          title: 'Tin nổi bật',
          align: 'center',
          width: 100,
          renderBodyCell: ({row, column}) => {
            let isHighlight
            if (row[column.field] === 2) {
              isHighlight = (
                <CIcon name="cil-check-circle" class="text-success"/>
              )
            }
            return isHighlight
          }
        },
        {
          title: 'Đăng bài',
          children: [
            {
              field: 'full_name',
              key: 'full_name',
              title: 'Người tạo',
              align: 'left',
              width: 130
            },
            {
              field: 'created_at',
              key: 'created_at',
              title: 'Ngày tạo',
              align: 'center',
              width: 180,
              renderBodyCell: ({row, column}) => {
                return moment(row[column.field]).format('YYYY/MM/DD - HH:mm:ss')
              }
            }
          ]
        },
        {
          field: 'approval_status',
          key: 'approval_status',
          title: 'Trạng thái',
          align: 'center',
          width: 150,
          fixed: 'right',
          renderBodyCell: ({row, column}) => {
            let _className
            NEWS_APPROVAL_STATUS.forEach(approvalStatus => {
              if (approvalStatus.id === row[column.field]) {
                _className = approvalStatus.className
              }
            })
            return (
              <b-form-select
                v-model={row[column.field]}
                options={NEWS_APPROVAL_STATUS}
                value-field="id"
                text-field="name"
                class={`select-render-body-cell ${_className}`}
                onChange={_approvalStatusId => {
                  this.onChangeValueCell(_approvalStatusId, 'approval_status', row.id, column.title)
                }}>
              </b-form-select>
            )
          }
        }
      ],
      expandOption: {
        trigger: 'cell',
        render: ({row}) => {
          return (
            <expand-info-list row={row}>
            </expand-info-list>
          )
        }
      },
      cellStyleOption: {
        bodyCellClass: ({column}) => {
          if (['status', 'is_highlight'].includes(column.field) || ['checkbox', 'expand'].includes(column.type)) {
            return 'cursor-pointer'
          }
        }
      },
      eventCustomOption: {
        bodyCellEvents: ({row, column}) => {
          return {
            click: () => {
              if (column.key !== 'expand' && !['title', 'status', 'is_highlight', 'approval_status'].includes(column.field)) {
                const currentRowKey = row['id']
                this.$refs.ccVeTable.changeSelectedRowKeysByRowClick(currentRowKey)
              }
            },
            dblclick: () => {
              switch (column.field) {
                case 'status':
                  this.onChangeValueCell(row[column.field] === 1 ? 2 : 1, 'status', row.id, column.title)
                  break
                case 'is_highlight':
                  this.onChangeValueCell(row[column.field] === 1 ? 2 : 1, 'is_highlight', row.id, column.title)
                  break
              }
            }
          }
        }
      }
    }
  },
  created() {
    const _path = this.$route.path.substring(1)
    this.pathUrl = _path.split('/')[1]
    if (this.pathUrl === 'by-user' || this.pathUrl === 'by-me') {
      if (this.$route.params && this.$route.params.userId) {
        this.pFullName = this.$route.params.fullName
      } else {
        this.pFullName = this.accountDetail['full_name']
      }
      document.title = `Tin quy hoạch của: ${this.pFullName}`
    }
  },
  async mounted() {
    if (this.$refs.ccVeTable) {
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('bản tin')
    }
  },
  computed: {
    ...mapState('user', ['accountDetail'])
  },
  methods: {
    ...mapActions('zoneNews', ['getDataList', 'updateOnCellTable', 'deleteSelectedList']),
    onOpenedSidebar() {
      this.$refs.filterPanel.getUserListWhenOpenSidebar()
    },
    async filterListWithCondition() {
      this.$refs.sidebarRightFilter.$refs.ccSidebar.hide()
      this.$refs.ccVeTable.$refs.dataAllListPagination.currentPage = 1
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('bản tin')
    },
    resetCondition() {
      this.$refs.filterPanel.resetCondition()
    },
    async getDataTable(pageSize, currentPage = 1) {
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.show()
      if (this.$cookies.isKey('userInfo')) {
        if (this.pathUrl === 'by-user' || this.pathUrl === 'by-me') {
          const _initFilterUserId = []
          if (this.$route.params && this.$route.params.userId) {
            _initFilterUserId.push(Number(this.$route.params.userId))
          } else {
            _initFilterUserId.push(this.$cookies.get('userInfo')['userId'])
          }
          this.newsTypeScreen[this.pathUrl]['filter']['user_ids'] = _initFilterUserId
        }
      }
      const _initFilterList = Object.assign({}, this.newsTypeScreen[this.pathUrl]['filter'])
      let _param = {
        current_page: currentPage,
        page_size: pageSize,
        filter: _initFilterList
      }
      const _filterMap = this.$refs.filterPanel.filterMap
      _.merge(_param['filter'], _filterMap)
      await this.getDataList(_param)
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.close()
    },
    async onChangeItemsPerPage(_itemsPerPage) {
      await this.getDataTable(_itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('bản tin')
    },
    onChangePagination(_currentPage) {
      this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage, _currentPage)
    },
    async onChangeValueCell(value, key, rowId, title) {
      const _param = {
        id: rowId,
      }
      _param[key] = value
      const res = await this.updateOnCellTable(_param)
      await this.showToastUpdateOrDeleteOnList(res, title, 0)
    },
    async showToastUpdateOrDeleteOnList(_res, _titleField, _countItemDeleted) {
      if (_res) {
        if (_res === 'updateOnCellTableSuccess') {
          SHOW_TOAST_2('success', `Cập nhật <b>"${_titleField}"</b> thành công.`)
        } else if (_res === 'deleteSelectedTableSuccess') {
          SHOW_TOAST_2('success', `Xóa thành công <b>${_countItemDeleted}</b> bản tin.`)
        }
      } else {
        SHOW_TOAST_2('error', 'Thực hiện thất bại.')
      }
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage, this.$refs.ccVeTable.$refs.dataAllListPagination.currentPage)
    },
    async deleteSelectedTable() {
      const _countItemDeleted = this.$refs.ccVeTable.dataTableSelected.length
      const confirm = window.confirm(`Bạn có chắc chắn muốn xóa ${_countItemDeleted} bản tin?`)
      if (confirm) {
        if (this.$refs.ccVeTable.dataTableSelected && this.$refs.ccVeTable.dataTableSelected.length) {
          const res = await this.deleteSelectedList(this.$refs.ccVeTable.dataTableSelected)
          if (res && res === 'deleteSelectedTableSuccess') {
            this.$refs.ccVeTable.unselectedAll()
          }
          await this.showToastUpdateOrDeleteOnList(res, null, _countItemDeleted)
        }
      }
    },
    getItemSelectedLength(value) {
      this.itemSelectedLength = value
    }
  }
}
</script>

<style scoped></style>
